<template>
  <div class="in-lesson-course-config-section-info">
    <a-table
      v-if="isShowLessColumn"
      :columns="LessColumn"
      :data-source="coursewareFragments"
      :pagination="false"
      :show-header="false"
      :scroll="{ y: `calc(100vh - 325px)` }"
      row-key="index"
    >
      <div
        slot="sections"
        slot-scope="text, record, index"
        class="section-name"
        @click.stop="play(record)"
      >
        <PartMsg
          is-show-less-column
          :is-show="isShow"
          :info="record"
          :is-cur="(currentPlay.type === 1 && currentPlay.index === record.index)"
          :index="index"
        />
      </div>
    </a-table>
    <a-table
      v-else
      :columns="columns"
      :data-source="coursewareFragments"
      :pagination="false"
      :show-header="false"
      :scroll="scroll"
      row-key="index"
    >
      <div
        slot="sections"
        slot-scope="text, record, index"
        class="section-name"
        @click.stop="play(record)"
      >
        <PartMsg :is-show="isShow" :info="record" :is-cur="(currentPlay.type === 1 && currentPlay.index === record.index)" :index="index" />
      </div>
      <span slot="before" slot-scope="text, record">
        <a-checkbox v-gdd-hide :checked="record.before" @change="(value) => changeVal(record, 'before', value)" :disabled="record.study || !editEnable">
          课前学
        </a-checkbox>
      </span>
      <span slot="middle" slot-scope="text, record">
        <a-checkbox v-gdd-hide :checked="record.among" @change="(value) => changeVal(record, 'among', value)" :disabled="record.study || !editEnable">
          课中学
        </a-checkbox>
      </span>
      <span slot="after" slot-scope="text, record">
        <a-checkbox v-gdd-hide :checked="record.after" @change="(value) => changeVal(record, 'after', value)" :disabled="record.study || !editEnable">
          课后学
        </a-checkbox>
      </span>
      <span v-gdd-hide slot="study" slot-scope="text, record">
        <div class="not-choice">
          <span :class="record.study ? 'active' : ''" style="margin-right:8px">不学</span>
          <a-switch :checked="record.study" @change="(value) => changeVal(record, 'study', value)" :disabled="!editEnable" />
        </div>
      </span>
    </a-table>
  </div>
</template>
<script>

import { getColumns } from './columns'
import PartMsg from '@/components/PartMsg.vue'

export default {
  components: { PartMsg },
  props: {
    coursewareFragments: {
      type: Array,
      default: () => []
    },
    editEnable: {
      type: Boolean,
      default: () => false
    },
    currentPlay: {
      type: Object,
      default: () => { }
    },
    isShow: Boolean,
    isShowLessColumn: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showLess: true,
      LessColumn: getColumns(true),
      columns: getColumns(),
      scroll: {
        y: `calc(100vh - 298px)`
      }
    }
  },
  methods: {
    changeVal(record, key, value) {
      if (value instanceof Object) value = value.target.checked
      console.log('record, key, value', record, key, value)
      this.$emit('updateList', record.index, key, value)
    },
    formatDuration(duration) {
      duration = Math.floor(duration)
      const duartionInDays = duration % (24 * 60 * 60)
      const hours = parseInt(duartionInDays / 3600) + ''
      const minutes = parseInt((duartionInDays % 3600) / 60) + ''
      const seconds = parseInt((duartionInDays % 3600) % 60) + ''
      return `${hours.padStart(2, '0')}:${minutes.padStart(2, '0')}:${seconds.padStart(2, '0')} `
    },
    play(record) {
      console.log('record')
      this.$emit('play', record)
    }
  }
}
</script>
<style scoped lang="less">

  .in-lesson-course-config-section-info {
    .not-choice {
      color: #505873;
      height: 100%;
      & > .active {
        color: #FF8800;
      }
    }

    :deep(.ant-table-wrapper .ant-table .ant-table-tbody > tr > td) {
      padding: 8px;
    }

    :deep(.ant-table-fixed-right) {
      .ant-table-body-outer {
        margin-bottom: -6px !important;
      }
       tr > td {
        padding-top: 16px !important;
       }
    }
    :deep(.ant-table-tbody > tr > td) {
      height: 81px !important;
    }
  }
</style>